/* eslint 'no-redeclare': 'off', eqeqeq: 'off' */
import React, { Component } from 'react';
import { connect } from "react-redux";
import { Label,Button,Nav,NavItem,NavLink,TabContent,TabPane } from 'reactstrap';
import { Icon } from 'semantic-ui-react';
import classnames from 'classnames';
import {GetInvoiceTemplate,PutInvoiceTemplate,PostFacilityLogo,GetInvoiceLogo,PostFacilityBackgroundImage,RestoreFacilityBackgroundImage,DeleteFacilityInvoiceLogo,GetFacilityImage } from '../../../../../action/invoiceAction';

class Brand extends Component {

    constructor(props) {
        super(props);
        this.state = {
            image_name_background_image: '',
            file_background_image: '',
            imagePreviewUrl_Facility: '',
            file: '',
            image_name: '',
            imagePreviewUrl: '',
            invoiceSetupId:'',
            invoice_number_preview: '',
            payment_remit_to: '',
            custom_text_above: '',
            custom_text_below: '',
            activeTab: '1',
            errorMessage: '',
            isError: false,
        }
        this.RestoreImage = this.RestoreImage.bind(this);
        this.toggle = this.toggle.bind(this);
        this.DeleteLogo = this.DeleteLogo.bind(this);
    }

    componentDidMount() {
        this.props.GetInvoiceLogo();
        this.props.GetFacilityImage();
        this.props.GetInvoiceTemplate();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props != nextProps) {
            if (nextProps.response_from_reducer.InvoiceTemplate !== false && nextProps.response_from_reducer.InvoiceTemplate.length !== 0) {
                var url = nextProps.response_from_reducer.InvoiceTemplate.logoSrc;
                var filename = url.substring(url.lastIndexOf('/')+1);
                this.setState({
                    image_name: filename,
                    invoiceSetupId: nextProps.response_from_reducer.InvoiceTemplate.invoiceSetupId,
                    invoice_number_preview: nextProps.response_from_reducer.InvoiceTemplate.invoicePrefix,
                    payment_remit_to: nextProps.response_from_reducer.InvoiceTemplate.remitToAddress,
                    custom_text_above: nextProps.response_from_reducer.InvoiceTemplate.aboveInvoiceText,
                    custom_text_below: nextProps.response_from_reducer.InvoiceTemplate.belowInvoiceText,
                });
            }
            if (nextProps.response_from_reducer.Invoicelogo != null) {
                this.setState({
                    imagePreviewUrl: nextProps.response_from_reducer.Invoicelogo
                });
            }
            if(nextProps.response_from_reducer.FacilityImageDetail != undefined && nextProps.response_from_reducer.FacilityImageDetail != false)
            {
                var url = nextProps.response_from_reducer.FacilityImageDetail.logoSrc;
                var filename = url.substring(url.lastIndexOf('/')+1);
                this.setState({image_name_background_image: filename});
            }
        }
    }

    handleFileBeforeUpload(file,fileSize){
        let hasError = false;
        if (file) {
            if(file.type == "image/jpeg" || file.type == "image/png" || file.type == "image/gif" || file.type == "application/pdf"){
                if(file.size > fileSize){
                    hasError = true;
                    this.setState({
                        isError: true,
                        errorMessage: " An error has occurred. "+file.name+" file size limit exceeded."
                    })
                }
            }else{
                hasError = true;
                this.setState({
                    isError: true,
                    errorMessage: " An error has occurred. "+file.name+" file type not supported."
                })
            }
        }
        return hasError;
    }

    _handleImageChange(e){
        this.setState({
            isError: false,
            errorMessage: ''
        })
        e.preventDefault();
        let reader = new FileReader();
        let file = e.target.files[0];
        const inValidImage= this.handleFileBeforeUpload(file,10000000);
        if(!inValidImage){
            reader.onloadend = () => {
                this.setState({
                    image_name: file.name,
                    file: file,
                    imagePreviewUrl: reader.result
                },()=>{
                    const data = new FormData();
                    data.append('file', file);
                    this.props.PostFacilityLogo(data);
                });
            }
           reader.readAsDataURL(file);
        }
    }

    RestoreImage() {
        const data = new FormData();
        this.props.RestoreFacilityBackgroundImage(data);
        this.setState({
            image_name_background_image : ''
        });
    }
    
    DeleteLogo(){
        const data = new FormData();
        this.props.DeleteFacilityInvoiceLogo(data);
        this.setState({
            image_name : ''
        });
    }

    _handleBackgroundImage(e){
        this.setState({
            isError: false,
            errorMessage: ''
        })
        e.preventDefault();
        let reader = new FileReader();
        let file = e.target.files[0];
        const inValidBgImage= this.handleFileBeforeUpload(file,25000000);
        if(!inValidBgImage){
            reader.onloadend = () => {
                this.setState({
                    image_name_background_image: file.name,
                    file_background_image: file,
                    imagePreviewUrl_Facility: reader.result
                },()=>{
                    const data = new FormData();
                    data.append('file', file);
                    this.props.PostFacilityBackgroundImage(data);
                });
            }
           reader.readAsDataURL(file);
        }
    }

    toggle(tab){
        if(this.state.activeTab !== tab){
            this.setState({activeTab : tab, errorMessage: '', isError: false});
        }
    }

    render() {
        var label = this.props.getLabels;
        let Custom_logo = null, Custom_bgimage = null;

        Custom_logo = 
                    <div className="main_container" style={{height:'293px'}}>
                        <legend className="form_sub_title" style={{margin:'5px'}}>{label['TenantBrand.CustomLogo.Text'] !== undefined ? label['TenantBrand.CustomLogo.Text'] : "Custom Logo"}</legend>
                        <p style={{fontFamily:'Verdana',fontSize:'12px', margin:'5px'}}>{label['TenantBrand.CustomLogo.UAText.Text'] !== undefined ? label['TenantBrand.CustomLogo.UAText.Text'] : "Upload a logo image file that will appear on the upper left corner of invoices and employee web interface."} </p>
                        { (!this.state.isError) ? 
                            <Label className="workorderlbl-noentry" style={{margin:'5px'}}>{this.state.image_name != '' ? this.state.image_name : (label['TenantBrand.Default.Text'] !== undefined ? label['TenantBrand.Default.Text'] : "No file uploaded")}</Label> : 
                            <span>
                                <Icon name='exclamation triangle' style={{ 'color': '#D52B1E'}} />
                                <Label style={{ 'color': '#D52B1E', 'font-size': '12px', 'font-family': 'Arial', 'display': 'inline'}}>{this.state.errorMessage}</Label>
                            </span>
                        }
                        <br/>
                        <Label className="workorderedit-choosebtn" style={{margin:'5px'}}>
                            <input type="file" onChange={(e) => {this._handleImageChange(e); e.target.value = null}} />{label['TenantBrand.ChooseFile.Text'] !== undefined ? label['TenantBrand.ChooseFile.Text'] : "Choose File..." }
                        </Label>
                        <Button type="button"  disabled={!this.state.image_name || this.state.isError} className="workorderedit-RestoreButton" onClick={this.DeleteLogo}>{label['TenantInvoices.btnDelete.Text'] !== undefined ? label['TenantInvoices.btnDelete.Text'] : "Delete"} </Button><br />
                        <Label className="workorderlbl-noentry" style={{margin:'5px'}}>{label['TenantBrand.LogoMessage.Text'] !== undefined ? label['TenantBrand.LogoMessage.Text'] : "Files cannot be greater than 10 MB. Images with transparent backgrounds work best. Acceptable formats JPG, PDF, GIF or PNG"}</Label>
                    </div>
        
        Custom_bgimage =
                    <div className="main_container" style={{height:'293px'}}>
                        <legend className="form_sub_title" style={{margin:'5px'}}>{label['TenantBrand.CustomBackgroundImage.Text'] !== undefined ? label['TenantBrand.CustomBackgroundImage.Text'] : "Custom Background Image"}</legend>
                        <p style={{fontFamily:'Verdana',fontSize:'12px', margin:'5px'}}>{label['TenantBrand.CustomBackgroundImage.UAText.Text'] !== undefined ? label['TenantBrand.CustomBackgroundImage.UAText.Text'] : "Upload an image file that will appear as the background image on employee web interfaces."} </p>
                        { (!this.state.isError) ? 
                            <Label className="workorderlbl-noentry" style={{margin:'5px'}}>{this.state.image_name_background_image != '' ? this.state.image_name_background_image : (label['TenantBrand.Default.Text'] !== undefined ? label['TenantBrand.Default.Text'] : "No file uploaded")}</Label> : 
                            <span>
                                <Icon name='exclamation triangle' style={{ 'color': '#D52B1E'}} />
                                <Label style={{ 'color': '#D52B1E', 'font-size': '12px', 'font-family': 'Arial', 'display': 'inline'}}>{this.state.errorMessage}</Label>
                            </span>
                        }
                        <br/>
                        <Label className="workorderedit-choosebtn" style={{margin:'5px'}}>
                            <input type="file" onChange={(e) => {this._handleBackgroundImage(e); e.target.value = null}} />{label['TenantBrand.ChooseFile.Text'] !== undefined ? label['TenantBrand.ChooseFile.Text'] : "Choose File..."}
                        </Label>
                        <Button type="button" disabled={!this.state.image_name_background_image || this.state.isError} className="workorderedit-RestoreButton" onClick={this.RestoreImage}>{label['TenantBrand.RestoreImage.Text'] !== undefined ? label['TenantBrand.RestoreImage.Text'] : "Restore to Default"} </Button> <br />
                        <Label className="workorderlbl-noentry" style={{margin:'5px'}}>{label['TenantBrand.BgImageMessage.Text'] !== undefined ? label['TenantBrand.BgImageMessage.Text'] : "Files cannot be greater than 25 MB. Images with transparent backgrounds work best. Acceptable formats JPG, PDF, GIF or PNG"}</Label> 
                    </div>      
        return(        
            <div>
              <Nav>
                  <NavItem>
                    <NavLink className={classnames({ active: this.state.activeTab == '1' }, "NestedTab_header_link", "link_cursor")} style={{"margin-bottom": "-1px","position":"relative"}} onClick={() => { this.toggle('1'); }}>CUSTOM LOGO</NavLink>
                  </NavItem>
                  <NavItem>
                      <NavLink className={classnames({active: this.state.activeTab == '2'},"NestedTab_header_link", "link_cursor","Tab_space")} style={{"margin-bottom": "-1px","position":"relative"}} onClick={() => {this.toggle('2'); }}>CUSTOM BACKGROUND IMAGE</NavLink>
                  </NavItem>
              </Nav>
              <div>
                <TabContent activeTab = {this.state.activeTab}>
                    <TabPane tabId="1" className="tenant_content_border">{Custom_logo}</TabPane>
                    <TabPane tabId="2" className="tenant_content_border">{Custom_bgimage}</TabPane>
                </TabContent>
              </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        getLabels: state.CulturalLabelsRootReducer.LabelsBasedOnPreference,
        response_from_reducer: state.InvoiceRootReducer,   
    };
  };
  
  const mapDispatchToProps = dispatch => {
    return {
        GetInvoiceTemplate: () => dispatch(GetInvoiceTemplate()),
        GetInvoiceLogo: () => dispatch(GetInvoiceLogo()),
        PostFacilityLogo: (imagefile) => dispatch(PostFacilityLogo(imagefile)),
        PutInvoiceTemplate: (data) => dispatch(PutInvoiceTemplate(data)),
        PostFacilityBackgroundImage: (imagefile) => dispatch(PostFacilityBackgroundImage(imagefile)),
        GetFacilityImage: () => dispatch(GetFacilityImage()),
        RestoreFacilityBackgroundImage: (data) => dispatch(RestoreFacilityBackgroundImage(data)), 
        DeleteFacilityInvoiceLogo: (data) => dispatch(DeleteFacilityInvoiceLogo(data)) 
    };
  };


export default connect(mapStateToProps, mapDispatchToProps)(Brand);